module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("订单管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("订单列表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "class-name": "statistics"
    }
  }, [_c('i-col', {
    attrs: {
      "md": 4
    }
  }, [_vm._v("\n            筛选实付金额: "), _c('label', [_vm._v(_vm._s(_vm.filterStatistics.totalPayment))])]), _vm._v(" "), _c('i-col', {
    attrs: {
      "md": 3
    }
  }, [_vm._v("\n            筛选金额: "), _c('label', [_vm._v(_vm._s(_vm.filterStatistics.totalAmount))])]), _vm._v(" "), _c('i-col', {
    attrs: {
      "md": 3
    }
  }, [_vm._v("\n            筛选折扣: "), _c('label', [_vm._v(_vm._s(_vm.filterStatistics.totalDiscount))])])], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 7
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "创建时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "value": _vm.queryParam.startCreateDate
    },
    on: {
      "on-change": _vm.startCreateDateChange
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "2"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "value": _vm.queryParam.endCreateDate
    },
    on: {
      "on-change": _vm.endCreateDateChange
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 7
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "付款时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "value": _vm.queryParam.startTimeDate
    },
    on: {
      "on-change": _vm.startTimeDateChange
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "2"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "value": _vm.queryParam.endTimeDate
    },
    on: {
      "on-change": _vm.endTimeDateChange
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 4,
      "sm": 4,
      "md": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "创建人"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "全部"
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.creatorId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "creatorId", $$v)
      },
      expression: "queryParam.creatorId"
    }
  }, _vm._l((_vm.adminUser), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname) + "\n                ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 4,
      "sm": 4,
      "md": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "审核人"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "全部"
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.auditId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "auditId", $$v)
      },
      expression: "queryParam.auditId"
    }
  }, _vm._l((_vm.adminUserAudit), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname) + "\n                ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 4,
      "sm": 4,
      "md": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "审核状态"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.auditStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "auditStatus", $$v)
      },
      expression: "queryParam.auditStatus"
    }
  }, [_c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未审核")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("已审核")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 4,
      "sm": 4,
      "md": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID",
      "prop": "uid"
    }
  }, [_c('Input', {
    attrs: {
      "name": "uid"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 4,
      "sm": 4,
      "md": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "multiple": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.stateList),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "stateList", $$v)
      },
      expression: "queryParam.stateList"
    }
  }, [_c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("订单已添加")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("待支付")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("支付成功")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      ":xs": 4,
      "sm": 4,
      "md": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程类型"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.tchChannel),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchChannel", $$v)
      },
      expression: "queryParam.tchChannel"
    }
  }, _vm._l((_vm.$constant.tchChannel), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 8,
      "sm": 8,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "订单号",
      "prop": "uid"
    }
  }, [_c('Input', {
    attrs: {
      "name": "uid"
    },
    model: {
      value: (_vm.queryParam.orderId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "orderId", $$v)
      },
      expression: "queryParam.orderId"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "订单类型"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "multiple": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.channelList),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "channelList", $$v)
      },
      expression: "queryParam.channelList"
    }
  }, _vm._l((_vm.$constant.orderChannel), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "套餐"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "multiple": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.coursePackageList),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "coursePackageList", $$v)
      },
      expression: "queryParam.coursePackageList"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1-20"
    }
  }, [_vm._v("欧美20")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1-40"
    }
  }, [_vm._v("欧美40")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1-50"
    }
  }, [_vm._v("欧美50")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1-72"
    }
  }, [_vm._v("欧美72")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1-110"
    }
  }, [_vm._v("欧美110")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1-144"
    }
  }, [_vm._v("欧美144")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1-210"
    }
  }, [_vm._v("欧美210")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2-60"
    }
  }, [_vm._v("菲教60")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2-100"
    }
  }, [_vm._v("菲教100")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2-320"
    }
  }, [_vm._v("菲教320")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2-630"
    }
  }, [_vm._v("菲教630")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 12,
      "offset": "1"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n            ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addModal = true
      }
    }
  }, [_vm._v("添加订单")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.showAddOtherButton
    },
    on: {
      "click": function($event) {
        _vm.addOtherModal = true
      }
    }
  }, [_vm._v("添加补升订单")]), _vm._v(" "), _c('Button', {
    directives: [{
      name: "perm",
      rawName: "v-perm",
      value: ('713'),
      expression: "'713'"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "height": 680,
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/fundPackage/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "onSelection": _vm.onSelection,
      "operator": ""
    },
    on: {
      "on-sort-change": _vm.handleSortChange
    }
  }), _vm._v(" "), _c('add-order-modal', {
    attrs: {
      "value": _vm.addModal,
      "successCallback": _vm.search
    },
    on: {
      "on-close": function($event) {
        _vm.addModal = false
      }
    }
  }), _vm._v(" "), _c('edit-order-modal', {
    attrs: {
      "value": _vm.editModal,
      "fundData": _vm.editData,
      "successCallback": _vm.search
    },
    on: {
      "on-close": function($event) {
        _vm.editModal = false
      }
    }
  }), _vm._v(" "), _c('add-other-order-modal', {
    attrs: {
      "value": _vm.addOtherModal,
      "successCallback": _vm.search
    },
    on: {
      "on-close": function($event) {
        _vm.addOtherModal = false
      }
    }
  }), _vm._v(" "), _c('add-voucher-modal', {
    attrs: {
      "value": _vm.addVoucherModal,
      "data": _vm.editData,
      "successCallback": _vm.search
    },
    on: {
      "on-close": function($event) {
        _vm.addVoucherModal = false
      }
    }
  }), _vm._v(" "), _c('order-gift-modal', {
    attrs: {
      "value": _vm.giftModal,
      "order-id": _vm.giftOrderId
    },
    on: {
      "on-close": function($event) {
        _vm.giftModal = false
      }
    }
  }), _vm._v(" "), _c('ShowImageCarousel', {
    attrs: {
      "imgList": _vm.showImgList,
      "value": _vm.showImgModal
    },
    on: {
      "on-close": _vm.closeImgModal
    }
  }), _vm._v(" "), _c('OrderClassHourModal', {
    attrs: {
      "totalNum": _vm.totalNum,
      "fundPackageId": _vm.fundPackageId,
      "uid": _vm.uid
    },
    model: {
      value: (_vm.showOrderClassHourModal),
      callback: function($$v) {
        _vm.showOrderClassHourModal = $$v
      },
      expression: "showOrderClassHourModal"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46f91d6a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/FundPackageList.vue
// module id = 1775
// module chunks = 8